<template>
  <div class="px-2">
    <div class="d-flex align-center py-2">
      <span class="ml-1 font-19 font-weight-medium">Análise excesso de estoque</span>

      <div class="ml-3 cursor-pointer" @click="tipo_visao = (tipo_visao === 'F') ? 'Q' : 'F'">
        <v-icon size="20">mdi-swap-horizontal</v-icon>
        <span class="font-12 ml-1">{{ (tipo_visao === 'F') ? 'Visão financeira' : 'Visão quantitativa' }}</span>
      </div>

      <v-divider vertical class="mx-3" />

      <v-spacer />

      <FiltrosUniversalAvancado />

      <ExportacaoParaExcel />
    </div>

    <GridItens
      :tipo_visao="tipo_visao"
      @duplo-click:linha="linha => linha_duplamente_clicada = linha"
    />

    <LinhaDuplamenteClicada :linha="linha_duplamente_clicada" />
  </div>
</template>

<script>
import GridItens from "@/components/Diagnostico/ExcessoEstoque/GridItens";
import LinhaDuplamenteClicada from "@/components/Diagnostico/LinhaDuplamenteClicada/Index";
import ExportacaoParaExcel from "@/components/Diagnostico/ExportacaoParaExcel";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";

export default {
  name: "ExcessoEstoque",
  components: {
    FiltrosUniversalAvancado,
    ExportacaoParaExcel,
    GridItens,
    LinhaDuplamenteClicada
  },
  data: () => ({
    tipo_visao: localStorage.diagnostico_tipo_visao || 'F',
    linha_duplamente_clicada: null
  })
}
</script>

<style scoped>

</style>
